// Import model
import { FilterVinylCatalogItemRequest } from '../models/FilterVinylCatalogItemRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { VinylCatalogItemCondition } from '../models/VinylCatalogItemCondition';
import { VinylCatalogItemFields } from '../models/VinylCatalogItemFields';
import { VinylCatalogItemIndexedFields } from '../models/VinylCatalogItemIndexedFields';

// Import dependency serializers (for complex types)
import { VinylCatalogItemConditionSerializer } from './VinylCatalogItemConditionSerializer';
import { VinylCatalogItemFieldsSerializer } from './VinylCatalogItemFieldsSerializer';
import { VinylCatalogItemIndexedFieldsSerializer } from './VinylCatalogItemIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterVinylCatalogItemRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterVinylCatalogItemRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterVinylCatalogItemRequest instance
   */
  static deserialize(json: string): FilterVinylCatalogItemRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterVinylCatalogItemRequest instance
   */
  static fromObject(obj: any): FilterVinylCatalogItemRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterVinylCatalogItemRequest');
    }


    const instance: FilterVinylCatalogItemRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as VinylCatalogItemIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as VinylCatalogItemFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        VinylCatalogItemConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterVinylCatalogItemRequest instances
   */
  static deserializeArray(json: string): FilterVinylCatalogItemRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterVinylCatalogItemRequest instance to a JSON string
   */
  static serialize(instance: FilterVinylCatalogItemRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterVinylCatalogItemRequest instance to a plain object
   */
  static toObject(instance: FilterVinylCatalogItemRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        VinylCatalogItemConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterVinylCatalogItemRequest instances to a JSON string
   */
  static serializeArray(instances: FilterVinylCatalogItemRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
